// extracted by mini-css-extract-plugin
export default {"item":"ReviewHistory_item__GPqnN"};